import { NotesFormModel } from "../types/NotesFormModel";
import { getModifiedOrNull } from "@/lib/InputTransformerHelpers";
import { NotesFormInput } from "@/gql/graphql";

export const transformNotesFormToInput = (
  formModel: NotesFormModel,
  persisted: NotesFormModel
): NotesFormInput => {
  return {
    comment: getModifiedOrNull(formModel.comment, persisted.comment),
    externalComment: getModifiedOrNull(
      formModel.externalComment,
      persisted.externalComment
    ),
    note: getModifiedOrNull(formModel.note, persisted.note),
  };
};
